import styled from 'styled-components';

import Icon from '@asset/credential.icon.svg?react';
import { Button } from '@atom/button/button';
import { Text } from '@atom/typography/typography';

export const NewCredentialWrapper = styled.div`
  max-width: 318px;
  flex: 1;
`;

export const NewCredentialButton = styled(Button)`
  flex: 1;
  height: 40px;
`;

export const CredentialButtonTitle = styled(Text).attrs((props) => ({
  color: props.theme.Title.colorCredentialButtonTitle,
  size: 'm',
}))``;

export const CredentialIcon = styled(Icon)`
  fill: ${(props) => props.theme.Title.colorCredentialButtonTitle};
  width: 24px;
  height: 24px;
`;
